module.exports = __webpack_public_path__ + "static/img/tjhb.e4b653c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/tjhb.jpg
// module id = HHVv
// module chunks = 9